import { useTitle, DiaryEntryType, DayAndDatePicker, ApiQueries, useAppState, DiaryItem, NoItems } from "daymap-react"
import PageHeader from "../../containers/pageheader/pageheader"


import { Box, Skeleton, Typography } from "@mui/material";
import { PageContainer } from "../../components/layout"
import { useDiaryItemClick } from "../../components/diary";

type CalendarState = {
    date: Date
}

function Calendar() {
    useTitle("Calendar");
    const [state, setState] = useAppState<CalendarState>("ParentCalendar", { date: new Date() }, "session");
    const { date } = state;

    const updateDate = (newDate?: Date) => {
        if (Boolean(newDate)) {
            setState({ date: newDate! });
        }
    }

    return <Box>
        <PageHeader title="Calendar" />
        <PageContainer>
        <Typography>Showing events from:</Typography>
            {date && <>
                <DayAndDatePicker selectedDate={date} onChange={updateDate}/>
                <TodaysEvents date={date}/>
            </>}
        </PageContainer>
    </Box>
}


const TodaysEvents: React.FC<{date:Date}> = ({date}) => {
    const { handleItemClick, modalElement } = useDiaryItemClick();
    const {isPending, data} = new ApiQueries.calendars.DiaryItems({from: date,to: new Date(date.getFullYear(),11,31)}).ToQuery();
    if(isPending){
        return  (
            <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
                    <Skeleton variant="rounded" height={65} />
                    <Skeleton variant="rounded" height={65} />
                    <Skeleton variant="rounded" height={65} />
                    <Skeleton variant="rounded" height={65} />
                    <Skeleton variant="rounded" height={65} />
            </Box>
        )
    }    
    
    return (
        <>
            {modalElement}
            <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
                {data?.sort((x, y) =>{
                    return (x.Type == DiaryEntryType.Task ? x.Finish : x.Start).getTime() - (y.Type == DiaryEntryType.Task ? y.Finish : y.Start).getTime()
                })
                .map((item) => {
                    return <DiaryItem key={`${item.Type}_${item.ID}`} {...item} onClick={handleItemClick} />
                })}
                {!data || data.length == 0 ? <NoItems>There are no events for this date range</NoItems> : <></>}
            </Box>
        </>
    )
}

export default Calendar